import type { SessionMode } from '@/api/lcMarketing'

export const DEFAULT_SESSION_START_TIME = '10:30'
export const DEFAULT_SESSION_END_TIME = '12:00'

interface KstDateTimeParts {
  date: string
  time: string
}

interface DerivedSessionSchedule {
  startsAt: string
  endsAt: string
  applicationClosesAt: string
}

const KST_DATE_TIME_FORMATTER = new Intl.DateTimeFormat('en-CA', {
  timeZone: 'Asia/Seoul',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  hourCycle: 'h23',
})

export function toKstDateTimeParts(value: string): KstDateTimeParts {
  const parts = KST_DATE_TIME_FORMATTER.formatToParts(new Date(value))
  const part = (type: Intl.DateTimeFormatPartTypes) =>
    parts.find((item) => item.type === type)?.value ?? ''

  return {
    date: `${part('year')}-${part('month')}-${part('day')}`,
    time: `${part('hour')}:${part('minute')}`,
  }
}

export function deriveSessionSchedule(
  date: string,
  startTime: string,
  endTime: string,
  mode: SessionMode,
): DerivedSessionSchedule {
  const startsAt = fromKstDateTime(date, startTime)
  const endsAt = fromKstDateTime(date, endTime)
  const applicationClosesAt = mode === 'offline'
    ? fromKstDateTime(date, '00:00')
    : new Date(new Date(startsAt).getTime() - 30 * 60 * 1000).toISOString()

  return { startsAt, endsAt, applicationClosesAt }
}

export function hasValidSessionTimeRange(startTime: string, endTime: string): boolean {
  return startTime !== '' && endTime !== '' && endTime > startTime
}

function fromKstDateTime(date: string, time: string): string {
  return new Date(`${date}T${time}:00+09:00`).toISOString()
}
